<template>
    <section class="theme" v-if="getOpen && getThemes" @click="$store.dispatch('changeState', {element: 'theme', val: false})">
        <div class="theme-container" @click.stop>
            <div class="theme-item" @click="setTheme(theme)" v-for="theme in getThemes" :key="theme.name" :class="{active: getActiveTheme.name === theme.name}">
                <div class="theme-item__colors" :style="{background: getGradient(theme.colors)}"></div>
                <p class="theme-item__name">{{ theme.title }}</p>
            </div>
        </div>
    </section>
</template>
<script>
export default {
    name: 'theme',
    computed: {
        getOpen() {
            return this.$store.getters.getThemeModal
        },
        getThemes() {
            return this.$store.getters.getThemes
        },
        getActiveTheme() {
            return this.$store.getters.getActiveTheme
        }

    },
    methods: {
        getGradient(colors) {
            return `conic-gradient(${colors.toString()})`;
        },
        setTheme(theme) {
            this.$store.dispatch("setTheme", theme)
        }
    }
}
</script>